import React from "react";

import { Props } from "./types";

function useVisibilitySwitch(defaultState: boolean = false) {
  const [isVisible, setVisibility] = React.useState(defaultState);

  return {
    isVisible,
    show: () => setVisibility(true),
    hide: () => setVisibility(false),
  };
}

function VisibilitySwitch(props: Props) {
  const { isVisible, show, hide } = useVisibilitySwitch(props.defaultState);

  return (
    <React.Fragment>
      {props.renderChildren(isVisible, show, hide)}
    </React.Fragment>
  );
}

VisibilitySwitch.useVisibilitySwitch = useVisibilitySwitch;

export { VisibilitySwitch };
